import { render, staticRenderFns } from "./DemandList.vue?vue&type=template&id=bf38838e&scoped=true"
import script from "./DemandList.vue?vue&type=script&lang=js"
export * from "./DemandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38838e",
  null
  
)

export default component.exports